export const SECTIONS = [
  { id: 'about', labelKey: 'Quiz_Section_AboutYou' },
  { id: 'goals', labelKey: 'Quiz_Section_YourGoals' },
  { id: 'lifestyle', labelKey: 'Quiz_Section_Lifestyle' },
  { id: 'health', labelKey: 'Quiz_Section_Health' },
];

// Slide code → section id
// About You: name(1), supplements(2-5), gender(6), birthday(7), weight/height(8), country(9)
// Goals: purpose(10), focus areas(11), priority ranking(58), conditional goal sub-Qs(13-35), menopause(59-60)
// Lifestyle: healthy lifestyle(36), diet(37), fish(38), meat(39), grains(40),
//   fruits/veg(41), dairy(42), eating out(43), alcohol(44), coffee(45),
//   coffee alt(46), smoking(47)
// Health: sun(48), sedentary(49), exercise freq(50), exercise type(51),
//   allergies(52), iron(53), conditions(54), referral(55), thank-you(56)
const SLIDE_CODE_TO_SECTION = {
  1: 'about',
  2: 'about',
  3: 'about',
  4: 'about',
  5: 'about',
  6: 'about',
  7: 'about',
  8: 'about',
  9: 'about',
  10: 'goals',
  11: 'goals',
  12: 'health',
  58: 'goals',
  59: 'goals',
  60: 'goals',
  13: 'goals',
  14: 'goals',
  15: 'goals',
  16: 'goals',
  17: 'goals',
  18: 'goals',
  19: 'goals',
  20: 'goals',
  21: 'goals',
  22: 'goals',
  23: 'goals',
  24: 'goals',
  25: 'goals',
  26: 'goals',
  27: 'goals',
  28: 'goals',
  29: 'goals',
  30: 'goals',
  31: 'goals',
  32: 'goals',
  33: 'goals',
  34: 'goals',
  35: 'goals',
  36: 'lifestyle',
  37: 'lifestyle',
  38: 'lifestyle',
  39: 'lifestyle',
  40: 'lifestyle',
  41: 'lifestyle',
  42: 'lifestyle',
  43: 'lifestyle',
  44: 'lifestyle',
  45: 'lifestyle',
  46: 'lifestyle',
  47: 'lifestyle',
  48: 'health',
  49: 'health',
  50: 'health',
  51: 'health',
  52: 'health',
  53: 'health',
  54: 'health',
  55: 'health',
  56: 'health',
  57: 'health',
};

export function getSlideSection(slideCode) {
  return SLIDE_CODE_TO_SECTION[slideCode] ?? 'about';
}

export function computeSectionProgress(currentSlideCode, quizData, slideNavigation) {
  const sectionSlides = {};
  SECTIONS.forEach((s) => {
    sectionSlides[s.id] = [];
  });

  const currentSec = getSlideSection(currentSlideCode);
  const currentSecIdx = SECTIONS.findIndex((s) => s.id === currentSec);

  quizData.forEach((slide) => {
    const code = slide[0]?.code;
    const posCode = slide[0]?.positionCode;
    if (code == null || posCode == null) return;
    const isActive = slideNavigation[posCode]?.active !== false;
    if (!isActive) return;
    const sec = getSlideSection(code);
    if (sectionSlides[sec]) {
      sectionSlides[sec].push({ code, posCode });
    }
  });

  return SECTIONS.map((sec, idx) => {
    const slides = sectionSlides[sec.id];
    const total = slides.length || 1;
    const isDone = idx < currentSecIdx;
    const isActive = idx === currentSecIdx;

    if (isDone) return { done: true, active: false, fillPercent: 100 };
    if (!isActive) return { done: false, active: false, fillPercent: 0 };

    const passed = slides.filter((s) => {
      const sPosSorted = Object.keys(slideNavigation)
        .map(Number)
        .sort((a, b) => a - b);
      const currentPosIdx = sPosSorted.indexOf(
        quizData.find((sl) => sl[0]?.code === currentSlideCode)?.[0]?.positionCode,
      );
      const slidePosIdx = sPosSorted.indexOf(s.posCode);
      return slidePosIdx < currentPosIdx;
    }).length;

    return { done: false, active: true, fillPercent: Math.round((passed / total) * 100) };
  });
}
